// extracted by mini-css-extract-plugin
module.exports = {"onboarding":"OnboardingDownload-moduleonboarding2o_"};